import { makeAutoObservable, runInAction } from 'mobx';
import { api } from '@/api';
import type { PlayerProfileDto } from '@/api/dto';
import type { RootStore } from './RootStore';

const DEV_MOCK: PlayerProfileDto = {
  stats: { games: 12, winrate: 58, avgScore: 41, words: 183, best: { word: 'компот', score: 9 } },
  history: [
    { letters: ['к', 'о', 'т'], mode: 'Матч', place: 1, players: 3, score: 74, when: '2026-06-09' },
    { letters: ['с', 'р', 'н'], mode: 'Соло', place: 1, players: 1, score: 32, when: '2026-06-08' },
    { letters: ['п', 'а', 'р'], mode: 'Матч', place: 2, players: 2, score: 55, when: '2026-06-07' },
  ],
};

export class ProfileStore {
  profile: PlayerProfileDto | null = null;
  isLoading = false;
  error: string | null = null;

  constructor(private _root: RootStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async load(): Promise<void> {
    if (!this._root.auth.isAuthenticated) return;
    this.isLoading = true;
    this.error = null;
    try {
      const data = await api.players.profile();
      runInAction(() => {
        this.profile = data;
        this.isLoading = false;
      });
    } catch {
      runInAction(() => {
        // In dev: fall back to mock so stats/history UI can be developed
        this.profile = import.meta.env.DEV ? DEV_MOCK : null;
        this.isLoading = false;
      });
    }
  }
}
